import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_user } from '@/hooks/store/use_slices';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';

export function G_BUTTON__fields_images_visibility_of__read_only() {
  const { user_settings } = use_slice_user(['user_settings']);

  async function onClick() {
    let user_settings_new = user_settings.clone();
    user_settings_new.generation_fields_show_read_only = !user_settings_new.generation_fields_show_read_only;
    await FN_USER_SETTINGS__update(user_settings_new);
  }

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="icon"
      {...{ onClick }}
      iconClassNameBase="!text-component-item-foreground !size-3"
      iconClassNameHovered="!text-bar-foreground"
      Icon={user_settings.generation_fields_show_read_only ? ICON__eye_solid : ICON__eye_slash_solid}
    />
  );
}
